'use client';

import React from 'react';
import {
  formatDateStringToLocalVN,
  mapModifiers,
  removeHTMLTags,
} from '@/utils/funtion';
import Link from 'next/link';
import Image from 'next/image';
import imgColumn from '@/assets/chart/colum.png';
import imgArea from '@/assets/chart/area.png';
import imgStack from '@/assets/chart/stack-value.png';
import imgStackPercent from '@/assets/chart/stack_percent.png';
import imgBar from '@/assets/chart/colum-vertical.png';
import imgLine from '@/assets/chart/line.png';
import imgColumnLine from '@/assets/chart/column-line.png';
import imgValue from '@/assets/chart/column-value.png';
import imgGroupColumn from '@/assets/chart/group-column.png';
import imgMaps from '@/assets/chart/maps.png';
import imgPie from '@/assets/chart/pie.png';
import { DATE_FORMAT_DD_MM_YYYY } from '@/utils/dateFormat';
import { useDispatch, useSelector } from 'react-redux';
import { setDetailUrl } from '@/stores/modules/detailUrl';
import { usePathname } from 'next/navigation';

interface IProps {
  data: any;
}
const chartImage: Record<string, any> = {
  column: imgColumn,
  bar: imgBar,
  line: imgLine,
  stack_value: imgValue,
  stack_percent: imgStackPercent,
  object: imgStack,
  column_line: imgColumnLine,
  area: imgArea,
  pie: imgPie,
  group_column: imgGroupColumn,
  maps: imgMaps,
};

const IndicatorRelateList: React.FC<IProps> = ({ data }) => {
  const pathname = usePathname();
  const segments = pathname?.split('/').filter(Boolean);

  const type = segments?.[1];

  const mappedType =
    type === 'kinh-te-dia-phuong'
      ? 'local_indicator'
      : type === 'du-lieu-kinh-te'
        ? 'indicator'
        : 'industry_indicator';

  const mappedTypes =
    type === 'kinh-te-dia-phuong'
      ? 'Kinh tế địa phương'
      : type === 'du-lieu-kinh-te'
        ? 'Dữ liệu kinh tế'
        : 'Kinh tế ngành';

  const dispatch = useDispatch();
  const userData = useSelector((state: any) => state.userData);
  const sections = [
    { title: 'Dữ liệu liên quan', dataKey: 'count' },
    { title: 'Dữ liệu mới nhất', dataKey: 'updated' },
    { title: 'Dữ liệu ngẫu nhiên', dataKey: 'random' },
  ];

  return (
    <div className={mapModifiers('p-indicator-list-relate')}>
      {sections.map(({ title, dataKey }) => (
        <div className="p-indicator-list-relate_session" key={dataKey}>
          <div className="p-indicator-list-relate_session_title">{title}</div>
          <div className="line"></div>
          <div className="p-indicator-list-relate_session_list">
            {data?.[dataKey]?.map((i: any, index: number) => {
              const newChartType = i?.chart_type || 'column';
              const queryParams = new URLSearchParams({
                type: mappedType,
                structure: i?.is_structure?.toString(),
                ...(i?.is_object_one_time && {
                  isObjectOneTime: i?.is_object_one_time?.toString(),
                }),
              });

              return (
                <Link
                  href={`/thong-tin-chi-tiet/${i?.slug}/${i?.id}?${queryParams?.toString()}`}
                  
                  className="p-indicator-list-relate_session_list_item"
                  key={index}
                >
                  <Image
                    src={chartImage[newChartType?.replaceAll('-', '_')]}
                    alt="avatar"
                    width={100}
                    height={80}
                    loading="lazy"
                  />
                  <div className="p-indicator-list-relate_session_list_item_info">
                    <div className="p-indicator-list-relate_session_list_item_type">
                      <p>{mappedTypes}</p>
                      <span>
                        {formatDateStringToLocalVN(
                          i?.updated_at,
                          DATE_FORMAT_DD_MM_YYYY,
                        )}
                      </span>
                    </div>
                    <div className="p-indicator-list-relate_session_list_item_title">
                      {i?.name}
                    </div>
                    <div className="p-indicator-list-relate_session_list_item_summary">
                      {removeHTMLTags(i?.summary)}
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default IndicatorRelateList;
